/**
 * @fileoverview Slice Redux para gerenciamento do modal de produtos.
 * Controla estado de abertura/fechamento do ProductManager.
 *
 * @module ProductManagerSlice
 * @since 1.0.0
 */

import { createSlice } from '@reduxjs/toolkit';

const productManagerSlice = createSlice({
  name: 'productManager',
  initialState: {
    isOpen: false,
  },
  reducers: {
    /**
     * Abre o modal de gerenciamento de produtos.
     */
    openProductManager: (state) => {
      state.isOpen = true;
    },
    /**
     * Fecha o modal de gerenciamento de produtos.
     */
    closeProductManager: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openProductManager, closeProductManager } = productManagerSlice.actions;
export default productManagerSlice.reducer;
